export const BlockType = {
    TEXT: 'TEXT',
    QUOTE: 'QUOTE',
    FAQ: 'FAQ',
    IMAGE: 'IMAGE',
    GALLERY: 'GALLERY',
    FULL_WIDTH_VIDEO: 'FULL_WIDTH_VIDEO',
    SPEAKER: 'SPEAKER',
    CTA_BUTTON: 'CTA_BUTTON',
} as const

export type BlockType = (typeof BlockType)[keyof typeof BlockType]

export const BlockTypeGroup = {
    TEXT: 'TEXT',
    MEDIA: 'MEDIA',
    CALL_TO_ACTION: 'CALL_TO_ACTION',
} as const

export type BlockTypeGroup = (typeof BlockTypeGroup)[keyof typeof BlockTypeGroup]
